/**
 * Admin Questions page component.
 *
 * Main page for question management in the admin panel.
 * Displays the QuestionManager component for CRUD operations on exam questions.
 *
 * Route: `/admin/questions`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminQuestionsPage
 */

import QuestionManager from '@/components/admin/QuestionManager';

export default function AdminQuestionsPage() {
  return <QuestionManager />;
}
